














import Vue from "vue";
import { AppI18n } from "@/common/plugins/i18n";

export default Vue.extend({
  name: "Search",
  props: {
    value: {
      type: String,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: String,
      required: false,
      default: "mdi-magnify",
    },
    placeholder: {
      type: String,
      required: false,
      default: AppI18n.t("common.search"),
    },
  },
  data() {
    return {
      searching: false,
    };
  },
  computed: {
    isClosed(): boolean {
      return !(this.expanded || this.searching || this.value?.length > 0);
    },
  },
});
